import axios from "axios";

export default function (vehicle) {
    return new Promise((resolve, reject) => {
        // Try to collect finance from session storage cache
        let cachedFinanceParams = sessionStorage.getItem('new.finance.params.' + vehicle.id);

        // if (cachedFinanceParams !== null) {
        //     try {
        //         // If we're able to parse what's stored, resolve the promise with it
        //         resolve(JSON.parse(cachedFinanceParams));
        //         return;
        //     } catch (error) {
        //         console.error(error);
        //     }
        // }

        const buildToOrderVehicleData = vehicle.getCodeweaversParameterRequestObject();
        if (buildToOrderVehicleData.IdentifierType == 'CapShortCode') {
            if (buildToOrderVehicleData.Type == 'Car') {
                buildToOrderVehicleData.IdentifierType = 'CapCarShortCode';
            } else {
                buildToOrderVehicleData.IdentifierType = 'CapLcvShortCode';
            }
        }

        // If we got this far, then we were unable to get finance params from cache
        // Build the JSON request data for this vehicle
        axios.post('https://services.codeweavers.net/api/finance/defaults', {
            Credentials: {
                ApiKey: "ONH75GHd8x0gu6yfJ6",
            },
            BuildToOrderVehicle: buildToOrderVehicleData,
        })
        .then(response => {
            if (typeof response.data.Error != 'undefined' && response.data.Error == true) {
                sessionStorage.setItem('new.finance.params.' + vehicle.id, JSON.stringify({}));
                reject();
                return;
            }
            sessionStorage.setItem('new.finance.params.' + vehicle.id, JSON.stringify(response.data));
            resolve(response.data);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        })
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/get-available-parameters.js